import config from "../config/config";
import axios from "axios";
import { getToken } from "../Token";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();
const token = getToken();

export const PriceRangeSlabApi = {
    addPriceRangeSlab: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/add-price-range-slab`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data
        };
        return await axios(axiosConfig);
    },

    updatePriceRangeSlab: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/update-price-range-slab`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data
        };
        return await axios(axiosConfig);
    },

    deletePriceRangeSlab: async (slab_id) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/delete-price-range-slab`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data: { slab_id }
        };
        return await axios(axiosConfig);
    },

    fetchPriceRangeSlabs: async (params) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/fetch-price-range-slabs`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data: params
        };
        return await axios(axiosConfig);
    },

    fetchPriceRangeSlab: async (slab_id) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/fetch-price-range-slab`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data: { slab_id }
        };
        return await axios(axiosConfig);
    }
};
